import styled from "styled-components";

export const CardContainer = styled.div`
	border-radius: var(--border-radius);
	background: #ffffff;
`;
